export enum NO_SALESFORCE_USER_DETAILS {
    NO_ACCOUNT = 'NOACCOUNT',
    NO_EMAIL = 'NOEMAIL',
    NO_USER_ID = 'NOUSERID',
}

export enum RECOMMENDATION_TARGET_TYPE {
    USER = 'USER',
    ACCOUNT = 'ACCOUNT',
}

export enum RECOMMENDATION_MODAL_CONTENT_URLS {
    GENESYS = '.genesys.com',
    GENESYS_CLOUD = '.genesys.cloud',
    MYPURECLOUD = '.mypurecloud.com',
    YOUTUBE = '.youtube.com',
    YOUTUBE2 = 'youtu.be',
    VIMEO = '.vimeo.com',
}

export enum RESOURCES_RECOMMENDATION_URLS {
    RESOURCECENTER = 'help.mypurecloud.com',
    RCWORKBENCH = 'rcworkbench.genesys.cloud',
    HELP = 'help.genesys.cloud',
    SERVICE_NOW = 'service-now.com/kb',
}
